import { useEffect, useState } from "react";
import rotateGif from "../../assets/gif/mobileRotate.gif";

export const INSTRUCTION_DATA = {
  INSTRUCTIONS: [
    {
      englishText:
        "Please tap on the button given at the bottom of this screen. This will capture your phone’s IMEI number, which is a unique identification number needed to activate your policy.",
      hindiText:
        "कृपया स्क्रीन के नीचे दिए गए बटन पर टैप करें। इससे आपके फोन का IMEI नंबर कैप्चर हो जाएगा, जो आपकी पॉलिसी को सक्रिय करने के लिए आवश्यक है।",
    },
    {
      englishText:
        "After the IMEI number is captured, you can stop the video recording on the other / secondary phone that you are using.",
      hindiText:
        "IMEI नंबर कैप्चर हो जाने के बाद, आप उस दूसरे फोन पर की जा रही वीडियो रिकॉर्डिंग को बंद कर सकते हैं।",
    },
    {
      englishText:
        "Once you stop the recording, please continue by following the next steps shown on that phone’s screen.",
      hindiText:
        "रिकॉर्डिंग बंद करने के बाद, कृपया उस फोन पर दिखाई जा रहे अगले चरणों का पालन करें।",
    },
  ],
  MODAL: {
    title: "Please rotate your phone / कृपया अपना फ़ोन घुमाएँ",
    gif: rotateGif,

    conclusion:
      "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    checkboxLabel: "I agree ",
    proceedLabel: "Continue to proceed",
  },
};

export const useInstructionData = () => {
  const [openModal, setOpenModal] = useState(true);
  const [tncChecked, setTncChecked] = useState(false);

  useEffect(() => {
    document.body.style.overflow = openModal ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [openModal]);

  return {
    openModal,
    setOpenModal,
    tncChecked,
    setTncChecked,
  };
};
